export class FlatArea {
  flatAreaId?: number;
  flatId?: number;
  name?: string = '';
  size?: number = 0;
  coverage?: string = '';
  number?: number;

  constructor(number?, name?, size?, coverage?) {
    this.flatAreaId = new Date().getTime();
    this.number = number;
    this.name = name;
    this.size = size;
    this.coverage = coverage;
  }

}
